import { ElasticSearch } from '@interfaces/models/elasticSearch';
import { ElasticSearchResponse } from '@interfaces/api/responses/elasticSearch';
import SearchService, { ProductSearchUseCase } from '@services/search-service';
import useUser from '@hooks/user/use-user';
import { usePreferences } from '@context/preferences.context';
import { RESULT_PER_PAGE } from '@constants/orders-sales';

const SORT_BY = 'recency';

const useSearch = () => {
  const { user } = useUser();
  const { country, currency, language } = usePreferences();

  const fetchSearch = async (searchQuery: string, page: number): Promise<ElasticSearchResponse> => {
    const requestPayload: Partial<ElasticSearch> = {
      q: searchQuery,
      pagination: {
        offset: (page - 1) * RESULT_PER_PAGE,
        limit: RESULT_PER_PAGE,
      },
      sortBy: SORT_BY,
      filters: {
        'seller.id': user ? [user.id] : undefined,
        sold: ['1'],
      },
      locale: {
        country,
        currency,
        language,
      },
    };

    const res = await SearchService.productSearch(requestPayload, ProductSearchUseCase.profileItemsSold);
    return res;
  };

  return { fetchSearch };
};

export default useSearch;
